var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningStopHandNotification = function SvgWarningStopHandNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#warning-stop-hand-notification_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.392 6.735c-.27-.111-.559-.169-.851-.169a2.762 2.762 0 0 0-.895.188 2.225 2.225 0 0 0-1.33 2.037v.193a2.225 2.225 0 0 0-3.25 1.975v6.675l-.568-.567a2.624 2.624 0 0 0-3.202-.394 2.225 2.225 0 0 0-.82 2.954l.048.086c2.014 3.58 3.205 5.658 3.556 6.197.071.11.143.22.215.328a7.1 7.1 0 0 0 5.613 3.188.61.61 0 0 0 .092.007h2.166a7.1 7.1 0 0 0 7.1-7.1v-9.208a2.225 2.225 0 0 0-3.25-1.974v-.192a2.225 2.225 0 0 0-3.25-1.975v-.193a2.223 2.223 0 0 0-1.374-2.056ZM17.15 7.844a1.025 1.025 0 0 0-.633.947V18a.6.6 0 1 1-1.2 0V10.96a1.025 1.025 0 1 0-2.05 0v8.092a.599.599 0 0 1-.6.633.599.599 0 0 1-.449-.202l-1.567-1.567a1.422 1.422 0 0 0-1.737-.213 1.025 1.025 0 0 0-.366 1.382c2.042 3.63 3.215 5.675 3.54 6.172l.21.322a5.899 5.899 0 0 0 4.867 2.655h2.003a5.9 5.9 0 0 0 5.9-5.9v-9.208a1.025 1.025 0 1 0-2.051.032v4.844a.6.6 0 1 1-1.2 0v-7.042a1.025 1.025 0 1 0-2.05 0v7.04a.6.6 0 1 1-1.2 0V8.791a1.025 1.025 0 0 0-.984-1.024H17.5c-.12.005-.24.03-.351.077Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "warning-stop-hand-notification_svg__a",
    x1: 0.969,
    y1: 0,
    x2: 0.969,
    y2: 34.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F69D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5D2C"
  })))));
};
export default SvgWarningStopHandNotification;